import HttpApi from 'i18next-http-backend';
import i18n from 'i18next';
import { getCurrentLocale } from '../common/utils/cookies';
import { initReactI18next } from 'react-i18next';

const localePlayer = getCurrentLocale();

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    react: {
      useSuspense: false,
      wait: true,
    },
    lng: localePlayer.toLocaleLowerCase(),
    fallbackLng: 'en_us',
    interpolation: {
      escapeValue: false, // React already prevents XSS attacks
    },
    backend: {
      loadPath: `locales/{{lng}}/{{ns}}.json?lng={{lng}}&{{ns}}`,
    },
    debug: process.env.NODE_ENV === 'development',
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false, // we use content as keys
  });

export default i18n;
